import { ComponentType, useEffect, useState } from "react";
import { useViewStateWrapper } from "../../../../store/store";
import { buildDrilldownCols } from "./drilldownColumns";

const noop = () => {};

// Reopens the drill-down table the user left open when they went into an incident.
const RestoredDrilldown = ({
  report,
  Modal,
}: {
  report: string;
  Modal: ComponentType<any>;
}) => {
  const [snapshot] = useState(() => {
    const saved = useViewStateWrapper.getState().drilldown;
    return saved?.report === report && saved.viaIncident ? saved : null;
  });
  const [open, setOpen] = useState(Boolean(snapshot));

  // Consume the flag so a later visit without an incident round trip doesn't reopen it.
  useEffect(() => {
    const { drilldown, setDrilldown } = useViewStateWrapper.getState();
    if (snapshot && drilldown?.viaIncident) {
      setDrilldown({ ...drilldown, viaIncident: false });
    }
  }, []);

  if (!snapshot || !open) return null;

  return (
    <Modal
      open
      facilityName={snapshot.facilityName}
      startDate={snapshot.startDate}
      endDate={snapshot.endDate}
      title={snapshot.title}
      tableData={snapshot.tableData}
      tableCols={buildDrilldownCols(snapshot.colsKey)}
      isLoading={false}
      closeFn={() => setOpen(false)}
      resetFn={noop}
      getUserCallback={noop}
      handlePdfExport={noop}
      handleCsvExport={noop}
    />
  );
};

export default RestoredDrilldown;
